import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty } from '~/types/specialty';

/**
 * Configuration for General Dentistry specialty referral form
 */
export const generalDentistryConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.GENERAL_DENTISTRY,
  displayName: 'General Dentistry',
  requiresToothSelection: true,
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [],
};
